export interface PillarArticle {
  slug: string;
  image: string;
}

export const pillarArticles: PillarArticle[] = [
  {
    slug: "basetao-spreadsheet",
    image:
      "https://readdy.ai/api/search-image?query=Organized%20product%20research%20flat%20lay%20with%20a%20notebook%2C%20printed%20product%20photos%2C%20a%20ruler%20and%20a%20pencil%20on%20a%20warm%20cream%20desk%20with%20soft%20natural%20light%2C%20editorial%20planning%20aesthetic%2C%20high%20detail%2C%20clean%20minimal%20tone&width=800&height=600&seq=guide-spreadsheet&orientation=landscape",
  },
  {
    slug: "basetao-review",
    image:
      "https://readdy.ai/api/search-image?query=Magnifying%20glass%20resting%20on%20printed%20review%20documents%20and%20star%20rating%20cards%20on%20a%20soft%20sage%20green%20desk%20with%20gentle%20natural%20light%2C%20editorial%20research%20aesthetic%2C%20high%20detail%2C%20calm%20analytical%20tone&width=800&height=600&seq=guide-review&orientation=landscape",
  },
  {
    slug: "basetao-legit",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20shield%20with%20a%20checkmark%20beside%20a%20stack%20of%20verification%20documents%20on%20a%20warm%20terracotta%20desk%20with%20soft%20daylight%2C%20editorial%20trust%20and%20safety%20aesthetic%2C%20high%20detail%2C%20warm%20reassuring%20tone&width=800&height=600&seq=guide-legit&orientation=landscape",
  },
  {
    slug: "basetao-shipping",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20stacked%20cardboard%20parcel%20boxes%20with%20a%20shipping%20label%20and%20measuring%20tape%20on%20a%20light%20beige%20surface%20with%20soft%20natural%20light%2C%20editorial%20logistics%20aesthetic%2C%20high%20detail%2C%20clean%20minimal%20tone&width=800&height=600&seq=guide-shipping&orientation=landscape",
  },
  {
    slug: "basetao-warehouse",
    image:
      "https://readdy.ai/api/search-image?query=Organized%20warehouse%20shelving%20with%20neatly%20labeled%20storage%20boxes%20in%20warm%20neutral%20tones%20under%20soft%20industrial%20light%2C%20editorial%20storage%20aesthetic%2C%20high%20detail%2C%20clean%20organized%20tone&width=800&height=600&seq=guide-warehouse&orientation=landscape",
  },
  {
    slug: "basetao-qc",
    image:
      "https://readdy.ai/api/search-image?query=A%20camera%20and%20inspection%20checklist%20beside%20a%20folded%20garment%20on%20a%20light%20mint%20green%20table%20with%20soft%20natural%20light%2C%20editorial%20quality%20control%20aesthetic%2C%20high%20detail%2C%20fresh%20clean%20tone&width=800&height=600&seq=guide-qc&orientation=landscape",
  },
  {
    slug: "basetao-coupon",
    image:
      "https://readdy.ai/api/search-image?query=Paper%20discount%20coupon%20tags%20with%20a%20small%20pair%20of%20scissors%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20light%2C%20editorial%20savings%20aesthetic%2C%20high%20detail%2C%20clean%20minimal%20tone&width=800&height=600&seq=guide-coupon&orientation=landscape",
  },
  {
    slug: "basetao-sellers",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20storefront%20concept%20with%20product%20cards%20and%20rating%20stars%20arranged%20on%20a%20soft%20sand%20beige%20surface%20with%20gentle%20natural%20light%2C%20editorial%20marketplace%20aesthetic%2C%20high%20detail%2C%20warm%20minimal%20tone&width=800&height=600&seq=guide-sellers&orientation=landscape",
  },
  {
    slug: "basetao-safety",
    image:
      "https://readdy.ai/api/search-image?query=A%20padlock%20and%20a%20small%20safety%20checklist%20on%20a%20soft%20blush%20pink%20surface%20with%20gentle%20natural%20light%2C%20editorial%20security%20aesthetic%2C%20high%20detail%2C%20soft%20reassuring%20tone&width=800&height=600&seq=guide-safety&orientation=landscape",
  },
  {
    slug: "basetao-alternatives",
    image:
      "https://readdy.ai/api/search-image?query=Several%20comparison%20cards%20lined%20up%20on%20a%20warm%20cream%20desk%20with%20soft%20natural%20light%20and%20a%20small%20plant%2C%20editorial%20decision%20making%20aesthetic%2C%20high%20detail%2C%20clean%20balanced%20tone&width=800&height=600&seq=guide-alternatives&orientation=landscape",
  },
];